/// <reference path="../../../../../typings/index.d.ts" />
module Meevo.Plugins.Egifts {
    export class CheckMinPurchaseAmount implements angular.IDirective {
        require = '^form';
        restrict = 'A';
        link = (scope: any, element: angular.IAugmentedJQuery, attrs: any, form: any) => {
            scope.$watch(() => form[attrs.name].$viewValue,(newValue, oldValue) => {
                if(newValue === oldValue || !attrs['minAmount'] || !scope.$eval(attrs['isMinPurchaseAmountEnable'])) return;

                this.assignValidationError(form, attrs);
            });

            scope.$watch(() => attrs['minAmount'],(newValue, oldValue) => {
                if(newValue === oldValue || !scope.$eval(attrs['isMinPurchaseAmountEnable'])) return;

                this.assignValidationError(form, attrs);
            });

            scope.$watch(() => attrs['isMinPurchaseAmountEnable'], () => {
                if (scope.$eval(attrs['isMinPurchaseAmountEnable'])) {
                    this.assignValidationError(form, attrs);
                    return;
                }

                form[attrs.name].$setValidity('lessThenMinPurchase', true);
            });
        };
        constructor() {}

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new CheckMinPurchaseAmount();
            };
            directive.$inject = [];

            return directive;
        }

        private assignValidationError(form: any, attrs: any) {
            form[attrs.name].$setValidity('lessThenMinPurchase', true);

            if (Number(form[attrs.name].$viewValue) < Number(attrs['minAmount'])) {
                form[attrs.name].$setValidity('lessThenMinPurchase', false);
            }
        }
    }

    angular.module('meevo.plugins.egifts')
        .directive('checkMinPurchaseAmount', CheckMinPurchaseAmount.factory());
}